import React, { useState, useEffect, useRef, useCallback } from 'react'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Paper from '@material-ui/core/Paper';
import HttpService from '../../services/httpService';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Grid from "@material-ui/core/Grid";
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { CSVLink } from "react-csv";
import { useSelector } from 'react-redux';
import { ROLENAME, designDepartment, constantDepartmentId, salesDepartment } from '../../utils/index';
import { Link } from 'react-router-dom';
import { Autocomplete } from '@material-ui/lab';
import { Chip, InputLabel, Select, MenuItem } from '@material-ui/core';
import moment from 'moment';
import TablePagination from "@material-ui/core/TablePagination";
import * as XLSX from 'xlsx';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  container: {
    maxHeight: 450,
  },
  radioButton: {
    // padding:20,
    marginLeft: "20px"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },

  submitButton: {
  backgroundColor: '#F47E46',  // Decorpot Orange
  color: 'white',            // White text
  '&:hover': {
    backgroundColor: '#E0663D', // Darker Orange on hover
  },
  },
  downloadButton: {
  backgroundColor: '#355025',   // Dark Blue
  color: '#FFF2EB',             // White text
  '&:hover': {
    backgroundColor: '#4A6641', // Derived lighter Dark Blue
  },
  actionButton: {
    padding: '1',
    borderRadius: '20px',
    alignSelf: "center",
    "&:hover": { backgroundColor: "#7a7d7a", color: 'white' } },
  
  },
  clearButton: {
  backgroundColor: '#FFF2EB',   // Light Beige
  color: '#1C375D',             // Decorpot Orange text
  '&:hover': {
    backgroundColor: '#E7BAD0', // Light Pink on hover
  },
},
  searchButton: {
  backgroundColor: '#FDB913',  // Bright Yellow for emphasis
  color: '#1C375D',            // Dark Blue text for contrast
  '&:hover': {
    backgroundColor: '#E6A411', // Darker yellow on hover
  },
},

}))

const ViewCustomerSurveyForms = (props) => {
  const classes = useStyles();
  const history = useHistory();


  const [allExpCenter, setAllExpCenter] = useState([]);
  const [selectedCenters, setSelectedCenters] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([])
  const [commonLocation, setLocation] = useState([])
  const [searchInput, setSearchInput] = useState("")
  const { userDetails } = useSelector(state => state.user)
  const [radioValue, setRadioValue] = useState("")
  const [selectedValue, setSelectedValue] = useState('all');
  const [storeEmail, setStoreEmail] = useState([])
  const [page, setPage] = React.useState(0); // Page starts at 0
  const [rowsPerPage, setRowsPerPage] = React.useState(100); // Default limit   
  const [dateType, setDateType] = useState('form-submission'); // Default to form submission
  const [searched, setSearched] = useState("")
  const [totalLength, setTotalLength] = useState(0)
  const [searchTypes, setSearchTypes] = useState([{ name: 'Customer Name' }, { name: 'Email ID' }, { name: 'Lead No' }, { name: 'Project No' }, { name: 'Contact No' }, { name: 'Unique Lead No' }]);
  const [selectedSearchType, setSelectedSearchType] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');
  const [selectUserId, setStoreUserId] = useState('');
  const [storeExpId, setStoreExpId] = useState([])
  const [storeUserDetails, setUserDetails] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsersId, setSelectedUsersId] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [toggleSales, setToggleSales] = useState(false)
  const [toggleDesign, setToggleDeisgn] = useState(false)
  const [togleRowChanges,setTogleRowChanges] = useState(false)
  const [toggleExecution, setToggleExecution] = useState(false)


  const [open, setOpen] = useState(false);

  const getExpericenCenters = async () => {
    try {
      let res = await HttpService.getAllExperienceCenterSurveyForm(userDetails?._id);
      setAllExpCenter(res?.data?.user?.experienceCenters);
    } catch (error) {
      props.setLoading("Something Went Wrong", error);
    }
  };

  const handleSelectionChange = (newValue) => {
    setSelectedCenters(newValue);
  };

  const handleDateTypeChange = (event) => {
    setDateType(event.target.value);
  };
  const handleSelectChange = async (e) => {
    const newValue = e?.target?.value || selectedValue;
    setSelectedValue(newValue);

    let departmentId = null;

    if (["won", "lost", "salesHandover"].includes(newValue)) {
      departmentId = salesDepartment;
    } else if (["design", "design lost", "designHandover"].includes(newValue)) {
      departmentId = designDepartment;
    }

    if (departmentId) {
      try {
        const res = await HttpService.usersOfDepartment(departmentId);
        setUsersData(res.data);
      } catch (error) {
        console.error("Error fetching users of department:", error);
      }
    }

    getdataOnSelectedDate(newValue); // fetching form-related data
  };

  


  const getdataOnSelectedDates = async (userIds) => {
    let selectedIds = selectedCenters.map(center => center._id);
    let type = selectedValue;
    let obj = {
      startDate,
      endDate,
      experienceCenterId: selectedIds,
      selectedLocation: selectedLocation,
      customerId: storeExpId,
      selectUserId: userIds,
      page,
      limit: rowsPerPage,
      searchType: selectedSearchType?.name,
      search: searchInput,
    };

    props.setLoading(true);
    try {
      const response = await HttpService.filteredSurveyFormList(type, obj);
      setSurveyFormData(response?.data?.data);
      setTotalLength(response?.data?.total);

      let satisfactionlength = 0;
      response.data.data.forEach(entry => {
        if (entry.forms) {
          Object.keys(entry.forms).forEach(formType => {
            const formsArray = entry.forms[formType];

            formsArray.forEach(form => {
              let value = 0;
              satisfactionlength = form.satisfactionIndexRatio.length;
              form.satisfactionIndexRatio.forEach(satisfaction => {
                value += +satisfaction.actionSelected;
              });
              let total = value / satisfactionlength;
              form["satisfactionavg"] = total.toFixed(1);
            });
          });
        }
      });
    } catch (error) {
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error");
    }
    props.setLoading(false);
  };

  const handleDateSubmit = () => {
    handleSelectChange()
  }


  const [surveyFormData, setSurveyFormData] = useState([])
  const getSurveyForm = async (type) => {

    props.setLoading(true)
    try {
      const obj = {
        experienceCenterId: userDetails?.selectedExpCenter,
        page,
        limit: rowsPerPage
      };

      const response = await HttpService.getSurveyFormList(type, obj)

      setSurveyFormData(response.data.data)
      setTotalLength(response?.data?.total)
      let satisfactionlength = 0;
      response.data.data.forEach(entry => {
        // Check if 'forms' exists in the data object
        if (entry.forms) {
          // Loop through each form type in 'forms'
          Object.keys(entry.forms).forEach(formType => {
            const formsArray = entry.forms[formType]; // Access the array in each form

            formsArray.forEach(form => {
              let value = 0;
              satisfactionlength = form.satisfactionIndexRatio.length;
              form.satisfactionIndexRatio.forEach(satisfaction => {
                value += +satisfaction.actionSelected; // Add the 'actionSelected' value
              });
              let total = value / satisfactionlength;
              form["satisfactionavg"] = total.toFixed(1); // Add the average satisfaction to the form
            });
          });
        }
      });


    } catch (error) {
      props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    }
    props.setLoading(false)
  }

  // const showCustomerForm = (type, data) => {
  //   history.push(`/customer-survey-form-details`, {
  //     data: data,
  //     type: type
  //   });
  // }
  
  const showCustomerForm = (type, data) => {
    const url = `/customer-survey-form-details?type=${type}&data=${encodeURIComponent(JSON.stringify(data))}`;
    window.open(url, '_blank');
  };
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState();
  const [filterType, setFilterType] = useState('form-submission'); // Default to form submission




const locations = async () => {
  props.setLoading(true);
  try {
      let response = await HttpService.getLocation();
      const matchedUsers = response.data.filter(user => {
          return userDetails.selectedLocation.includes(user._id);
      });
      setLocation(matchedUsers)
  } catch (error) {
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
  }
  props.setLoading(false);
}

const handleMultipleLocationData = (newvalue) => {
  const store = newvalue.map(el => el._id);  // Store only _ids
  setSelectedLocation(store);
};

// Get full objects for Autocomplete display
const getSelectedObjects = () => {
  return commonLocation.filter(loc => selectedLocation.includes(loc._id));
};

const getdataOnSelectedDate = async (type) => {
  let selectedIds = selectedCenters.map(center => center._id);

  let obj = {
    startDate,
    endDate,
    experienceCenterId: selectedIds,
    selectedLocation: selectedLocation,
    customerId: storeExpId,
    selectUserId: selectedUsersId,
    page,
    limit: rowsPerPage,
    searchType: selectedSearchType?.name,
    search: searchInput,
    dateFilterType: dateType
  };

  props.setLoading(true);
  try {
    const response = await HttpService.filteredSurveyFormList(type, obj);

    const data = response?.data?.data;
    const total = response?.data?.total;

    if (Array.isArray(data)) {
      setSurveyFormData(data);
      setTotalLength(total ?? 0);

      let satisfactionlength = 0;

      data.forEach(entry => {
        if (entry?.forms) {
          Object.keys(entry.forms).forEach(formType => {
            const formsArray = entry.forms[formType];

            if (Array.isArray(formsArray)) {
              formsArray.forEach(form => {
                let value = 0;
                satisfactionlength = form?.satisfactionIndexRatio?.length ?? 0;

                if (satisfactionlength > 0) {
                  form.satisfactionIndexRatio.forEach(satisfaction => {
                    value += +satisfaction?.actionSelected || 0;
                  });

                  let total = value / satisfactionlength;
                  form["satisfactionavg"] = total.toFixed(1);
                } else {
                  form["satisfactionavg"] = "NA";
                }
              });
            }
          });
        }
      });
    } else {
      setSurveyFormData([]);
      setTotalLength(0);
    }

  } catch (error) {
    const msg = error?.response?.data?.message;
    if (msg) {
      props.setSnackInfo(msg, "error");
    }
    // Otherwise, don’t show "Something went wrong"
  } finally {
    props.setLoading(false);
  }
};



  const clearFilterDate = () => {
    setStartDate('');
    setSelectedSearchType([])
    setEndDate('');
    setSearchInput('')
    setSelectedCenters([])
    setUsersData([])
    setSelectedUsers([])
    setSelectedUsersId([])
    setSelectedRole('')
    setSelectedValue('all')
    getSurveyForm('')
    setTogleRowChanges(false)
  }



  const setHandleSearched = (value) => {
    setSearched(value)
    // requestSearch(selectedSearchType, value)
  }

  // const requestSearch = async (searchType, search) => {
  //   try {
  //     let data = {
  //       role: "Admin"
  //     }
  //     const response = await HttpService.getAllSearchSurveyLeads(searchType.name, search, userDetails.selectedExpCenter, data);

  //     // Extract customer IDs (assumed to be emails here)
  //     const extractedEmails = response.data.docs.flatMap(doc =>
  //       doc.projects.map(project => project.customerId._id).filter(id => id)
  //     );

  //     setStoreExpId(extractedEmails)

  //     // Assuming `surveyFormData` is available here

  //     // Check each form to see if its leadId.experienceCenterId matches any of the extracted emails
  //     const filteredSurveyForms = surveyFormData.filter(form => {
  //       const centerId = form?.leadId?.customerId?._id ? form?.leadId?.customerId?._id.toString() : null;
  //       // Ensure that centerId is not null before checking inclusion
  //       return centerId && extractedEmails.includes(centerId);
  //     });
  //     setSurveyFormData(filteredSurveyForms);



  //     // Store or use the extracted emails as needed
  //     // setStoreEmail(emails);
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }


  const setHandleSearchedByEnter = (e) => {
    if (e.keyCode === 13) {
      setSearched(searchInput)
      getdataOnSelectedDate('null')
    }
  }

  const handle_search_type_selection = (value) => {
    setSelectedSearchType(value)
    setSearchInput('')
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setTogleRowChanges(true)
    // getSurveyForm('yourType', newPage + 1, rowsPerPage); // newPage starts from 0
  };

 
  // Handler for changing rows per page
  const handleChangeRowsPerPage = useCallback((event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setTogleRowChanges(true)
    setSelectedValue(selectedValue)
    setPage(0); // Reset page to 0 when rows per page changes

    // Fetch data with new limit
  }, []);


  const handleSelectRoles = async (event) => {
    const selectedRole = event.target.value; // Get the selected role from the event
    setSelectedRole(selectedRole); // Update the state with the selected role
    try {
      // Make the API call, passing the selected role as a parameter
      let res = await HttpService.getSelectedUsersBasedOnRolesForSurveyForms(selectedRole);

      // Set user details based on the response
      setUsersData(res.data); // Update usersData with fetched users
      // setUserDetails(res.data);
    } catch (error) {
      // Handle any errors
      props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error");
    }
  };


  const handleMultipleUsers = (e, newValue) => {


    // Extract IDs from the selected users
    const selectedUserIds = newValue.map(user => user._id);  // Assuming each user object has an _id property
    setSelectedUsersId(selectedUserIds)


    // Pass the array of selected user IDs to the API
    getdataOnSelectedDates(selectedUserIds);

    // Update the state with the newly selected users
    setSelectedUsers(newValue);
  };


  useEffect(() => {
    if (userDetails.departmentId === salesDepartment) {

      // If department is sales, set "sales"
      // setSelectedValue('won')
      setToggleSales(true)
    }
    if (selectedValue === 'won' || selectedValue === 'lost' || selectedValue === 'design' || selectedValue === 'designlost') {
      setToggleSales(false)
    }

    if (userDetails.departmentId === designDepartment) {
      // If department is sales, set "sales"   alert("design toogle")
      // setSelectedValue('won')
      setToggleDeisgn(true)
    }
    if (selectedValue === 'design' || selectedValue === 'designlost') {
      setToggleDeisgn(false)
    }
    if (selectedValue === 'execution') {
      setToggleExecution(true)
    }

  }, [userDetails, selectedValue]); // Add `userDetails` as dependency



  useEffect(() => {
    getExpericenCenters()
    // getdataOnSelectedDate(selectedValue)
    if (selectedCenters.length > 0) {
      getdataOnSelectedDate(null);
    }
 
    if(togleRowChanges){
      getdataOnSelectedDate(selectedValue);
    }
    if (storeExpId.length > 0) {
      getdataOnSelectedDate(null)
    }
  }, [page, rowsPerPage, togleRowChanges])
  useEffect(()=>{
    getSurveyForm(null);
    locations()
  },[])

  useEffect(() => {
    getExpericenCenters()
    if (selectedCenters.length > 0) {
      getdataOnSelectedDate(selectedValue);
    }
    if(selectedValue !=='all'){
      getdataOnSelectedDate(selectedValue)
    }
    if(selectedLocation.length > 0) {
      getdataOnSelectedDate(selectedValue)
    }
    if (storeExpId.length > 0) {
      getdataOnSelectedDate(null)
    }
  }, [page, rowsPerPage, selectedCenters, storeExpId, selectedLocation])

  const downloadExcel = () => {
    // Define the table data structure based on the selectedValue
    const tableData = surveyFormData.map((row, i) => {
      // Common base data that is always included regardless of selection
      const baseData = {
        'S.No': i + 1,
        'Customer Name': row?.leadId?.customerId?.name || 'NA',
        'Lead No': row?.leadId?.lead_no || 'NA',
        'ERP Project No': row?.leadId?.erpProjectNo || 'NA',
        'City': row?.leadId?.city?.name || 'NA',
        'Experience Center': row?.leadId?.experienceCenterId?.name || 'NA',
        'Current Stage': row?.leadId?.currentStage || 'NA',
        'Apartment Name': row?.propertyType || 'NA',
      };
  
      // Check which form type is selected and only include relevant data
      switch (selectedValue) {
        case 'design':
          // Include only Design data
          baseData['Design Lead Owner'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.leadOwner?.name : 'NA';
          baseData['Design ADM'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.leadOwner?.assistantManagerId?.name : 'NA';
          baseData['Design ODM'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.leadId?.designManager?.name : 'NA';
          baseData['Design Date'] = row?.forms?.design?.length > 0 ? moment(row.forms.design[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Design FeedBack'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.feedback : 'NA';
          baseData['Design NPS Score'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.satisfactionavg : 'NA';
          break;
  
        case 'designlost':
          // Include only Design Lost data
          baseData['Design Lost Lead Owner'] = row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.leadOwner?.name : 'NA';
          baseData['Design Lost ADM'] = row?.forms?.designlost?.length > 0 ? row?.forms?.designlost[0]?.leadOwner?.assistantManagerId?.name : 'NA';
          baseData['Design Lost ODM'] = row?.forms?.designlost?.length > 0 ? row?.forms?.designlost[0]?.leadId?.designManager?.name : 'NA';
          baseData['Design Lost Date'] = row?.forms?.designlost?.length > 0 ? moment(row.forms.designlost[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Design Lost FeedBack'] = row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.feedback : 'NA';
          baseData['Design Lost NPS Score'] = row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.satisfactionavg : 'NA';
          break;
  
        case 'won':
          // Include only Sales Won data
          baseData['Sales Won Lead Owner'] = row?.forms?.won?.length > 0 ? row.forms.won[0]?.leadOwner?.name : 'NA';
          baseData['Sales Won Date'] = row?.forms?.won?.length > 0 ? moment(row.forms.won[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Sales Won FeedBack'] = row?.forms?.won?.length > 0 ? row.forms.won[0]?.comments : 'NA';
          baseData['Sales Won NPS Score'] = row?.forms?.won?.length > 0 ? row.forms.won[0]?.satisfactionavg : 'NA';
          break;
  
        case 'lost':
          // Include only Sales Lost data
          baseData['Sales Lost Lead Owner'] = row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.leadOwner?.name : 'NA';
          baseData['Sales Lost Date'] = row?.forms?.lost?.length > 0 ? moment(row.forms.lost[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Sales Lost FeedBack'] = row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.comments : 'NA';
          baseData['Sales Lost NPS Score'] = row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.satisfactionavg : 'NA';
          break;
  
          case 'execution': {
            // Include only Execution data
            const executionForm = row?.forms?.execution?.[0];
          
            baseData['Execution Lead Owner'] = executionForm?.leadOwner?.name || 'NA';
            
            {dateType === 'project-completion' && (
              baseData['Project Completion Date'] = row?.leadId?.executionCompletionDate
                ? moment(row.leadId.executionCompletionDate).format('DD-MM-YYYY')
                : 'NA'
            )};            
            baseData['NPS Recieved Date'] = row?.forms?.execution?.[0]?.satisfactionIndexRatio?.length > 0 &&
            moment(row.forms.execution[0]?.createdAt).isValid()
            ? moment(row.forms.execution[0].createdAt).format('DD-MM-YYYY')
            : 'NA';
            
            baseData['Execution FeedBack'] = executionForm?.additionalFeedback || 'NA';
            baseData['Execution NPS Score'] = executionForm?.satisfactionavg || 'NA';
            
            baseData['Sales Owner'] = executionForm?.leadId?.salesWonUserName || 'NA';
            baseData['Sales User FeedBack'] = executionForm?.feedbackWithSalesTeam || 'NA';
            baseData['Sales Rating'] = executionForm?.experienceWithSalesTeam || 'NA';
            
            baseData['Design Owner'] = executionForm?.leadId?.designSignOffUserName || 'NA';
            baseData['Designer FeedBack'] = executionForm?.feedbackWithDesignTeam || 'NA';
            baseData['Design Rating'] = executionForm?.experienceWithDesignTeam || 'NA';
          
            // ✅ Add Execution NPS (Average of 3 ratings)
            const executionScores = [];
            const satisfaction = parseFloat(executionForm?.satisfactionavg);
            const salesTeam = parseFloat(executionForm?.experienceWithSalesTeam);
            const designTeam = parseFloat(executionForm?.experienceWithDesignTeam);
          
            if (!isNaN(satisfaction)) executionScores.push(satisfaction);
            if (!isNaN(salesTeam)) executionScores.push(salesTeam);
            if (!isNaN(designTeam)) executionScores.push(designTeam);
          
            baseData['Project Handover Average NPS'] = executionScores.length > 0 
              ? (executionScores.reduce((sum, val) => sum + val, 0) / executionScores.length).toFixed(1) 
              : 'NA';
          
            break;
          }
          
          
  
        case 'salesHandover':
          // Include only Sales Handover data
          baseData['Sales Lead Owner'] = row?.forms?.execution?.length > 0 ? row?.leadId?.salesWonUserName : 'NA';
          baseData['Sales Experience Form Date'] = row?.forms?.execution?.length > 0 ? moment(row?.forms?.execution[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Sales Experience Rating'] = row?.forms?.execution?.length > 0 ? row?.forms?.execution[0]?.experienceWithSalesTeam : 'NA';
          break;
  
        case 'designHandover':
          // Include only Design Handover data
          baseData['Design Owner'] = row?.forms?.execution?.length > 0 ? row?.leadId?.designSignOffUserName : 'NA';
          baseData['Design Experience Form Date'] = row?.forms?.execution?.length > 0 ? moment(row?.forms?.execution[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Design Experience Rating'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.experienceWithDesignTeam : 'NA';
          break;
  
        case 'all':
          // Include ALL form types when "all" is selected
          // Design

          // Sales Won
          baseData['Sales Won Lead Owner'] = row?.forms?.won?.length > 0 ? row.forms.won[0]?.leadOwner?.name : 'NA';
          baseData['Sales Won Date'] = row?.forms?.won?.length > 0 ? moment(row.forms.won[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Sales Won FeedBack'] = row?.forms?.won?.length > 0 ? row.forms.won[0]?.comments : 'NA';
          baseData['Sales Won NPS Score'] = row?.forms?.won?.length > 0 ? row.forms.won[0]?.satisfactionavg : 'NA';
        
          // Sales Lost
          baseData['Sales Lost Lead Owner'] = row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.leadOwner?.name : 'NA';
          baseData['Sales Lost Date'] = row?.forms?.lost?.length > 0 ? moment(row.forms.lost[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Sales Lost FeedBack'] = row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.comments : 'NA';
          baseData['Sales Lost NPS Score'] = row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.satisfactionavg : 'NA';
  
          baseData['Design Lead Owner'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.leadOwner?.name : 'NA';
          baseData['Design ADM'] = row?.forms?.design?.length > 0 ? row?.forms?.design[0]?.leadOwner?.assistantManagerId?.name : 'NA';
          baseData['Design ODM'] = row?.forms?.design?.length > 0 ? row?.forms?.design[0]?.leadId?.designManager?.name : 'NA';          
          baseData['Design Date'] = row?.forms?.design?.length > 0 ? moment(row.forms.design[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Design FeedBack'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.feedback : 'NA';
          baseData['Design NPS Score'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.satisfactionavg : 'NA';
  
          // Design Lost
          baseData['Design Lost Lead Owner'] = row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.leadOwner?.name : 'NA';
          baseData['Design Lost ADM'] = row?.forms?.designlost?.length > 0 ? row?.forms?.designlost[0]?.leadOwner?.assistantManagerId?.name : 'NA';
          baseData['Design Lost ODM'] = row?.forms?.designlost?.length> 0 ? row?.forms?.designlost[0]?.leadId?.designManager?.name : 'NA';
          baseData['Design Lost Date'] = row?.forms?.designlost?.length > 0 ? moment(row.forms.designlost[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Design Lost FeedBack'] = row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.feedback : 'NA';
          baseData['Design Lost NPS Score'] = row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.satisfactionavg : 'NA';
  
    
          // Execution
          baseData['Execution Lead Owner'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.leadOwner?.name : 'NA';
          baseData['Execution Date'] = row?.forms?.execution?.length > 0 ? moment(row.forms.execution[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
          baseData['Execution FeedBack'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.additionalFeedback : 'NA';
          baseData['Execution NPS Score'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.satisfactionavg : 'NA';

          baseData['Sales User FeedBack'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.feedbackWithSalesTeam : 'NA';
          baseData['Sales Rating'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.experienceWithSalesTeam : 'NA';
         

          baseData['Designer FeedBack'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.feedbackWithDesignTeam : 'NA';
          baseData['Design Rating'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.experienceWithDesignTeam : 'NA';
         

          // Calculate Average NPS Score when all forms are selected
          const scores = [];
          
          // Push all NPS values after validation
          if (row?.forms?.won?.length > 0 && row?.forms?.won?.[0]?.satisfactionavg) {
            scores.push(parseFloat(row.forms.won[0].satisfactionavg));
          }
  
          if (row?.forms?.lost?.length > 0 && row?.forms?.lost?.[0]?.satisfactionavg) {
            scores.push(parseFloat(row.forms.lost[0].satisfactionavg));
          }
  
          if (row?.forms?.design?.length > 0 && row?.forms?.design?.[0]?.satisfactionavg) {
            scores.push(parseFloat(row.forms.design[0].satisfactionavg));
          }
  
          if (row?.forms?.designlost?.length > 0 && row?.forms?.designlost?.[0]?.satisfactionavg) {
            scores.push(parseFloat(row.forms.designlost[0].satisfactionavg));
          }
  
          if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.satisfactionavg) {
            scores.push(parseFloat(row.forms.execution[0].satisfactionavg));
          }
  
          if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.experienceWithSalesTeam) {
            scores.push(parseFloat(row.forms.execution[0].experienceWithSalesTeam));
          }
  
          if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.experienceWithDesignTeam) {
            scores.push(parseFloat(row.forms.execution[0].experienceWithDesignTeam));
          }
  
          // Now calculate average for download
          if (scores.length > 0) {
            const sum = scores.reduce((acc, score) => acc + score, 0);
            const average = (sum / scores.length).toFixed(2);
            baseData['Average NPS Score'] = `${average} / 5`;
          } else {
            baseData['Average NPS Score'] = 'NA';
          }
          break;
  
        default:
          // If no specific selection or invalid selection, fall back to toggles
          if (toggleDesign) {
            baseData['Design Lead Owner'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.leadOwner?.name : 'NA';
            baseData['Design ADM'] = row?.forms?.design?.length > 0 ? row?.forms?.design[0]?.leadOwner?.assistantManagerId?.name : 'NA';
            baseData['Design ODM'] = row?.forms?.design?.length > 0 ? row?.forms?.design[0]?.leadId?.designManager?.name : 'NA';
            baseData['Design Date'] = row?.forms?.design?.length > 0 ? moment(row.forms.design[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
            baseData['Design NPS Score'] = row?.forms?.design?.length > 0 ? row.forms.design[0]?.satisfactionavg : 'NA';
  
            baseData['Design Lost Lead Owner'] = row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.leadOwner?.name : 'NA';
            baseData['Design Lost ADM'] = row?.forms?.designlost?.length > 0 ? row?.forms?.designlost[0]?.leadOwner?.assistantManagerId?.name : 'NA';
            baseData['Design Lost ODM'] = row?.forms?.designlost?.length> 0 ? row?.forms?.designlost[0]?.leadId?.designManager?.name : 'NA';
            baseData['Design Lost Date'] = row?.forms?.designlost?.length > 0 ? moment(row.forms.designlost[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
            baseData['Design Lost NPS Score'] = row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.satisfactionavg : 'NA';
          }
  
          if (toggleSales) {
            baseData['Sales Won Lead Owner'] = row?.forms?.won?.length > 0 ? row.forms.won[0]?.leadOwner?.name : 'NA';
            baseData['Sales Won Date'] = row?.forms?.won?.length > 0 ? moment(row.forms.won[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
            baseData['Sales Won NPS Score'] = row?.forms?.won?.length > 0 ? row.forms.won[0]?.satisfactionavg : 'NA';
  
            baseData['Sales Lost Lead Owner'] = row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.leadOwner?.name : 'NA';
            baseData['Sales Lost Date'] = row?.forms?.lost?.length > 0 ? moment(row.forms.lost[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
            baseData['Sales Lost NPS Score'] = row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.satisfactionavg : 'NA';
          }
  
          if (toggleExecution) {
            baseData['Execution Lead Owner'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.leadOwner?.name : 'NA';
            baseData['Execution Date'] = row?.forms?.execution?.length > 0 ? moment(row.forms.execution[0]?.createdAt).format('DD-MM-YYYY') : 'NA';
            baseData['Execution NPS Score'] = row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.satisfactionavg : 'NA';
          }
          break;
      }
  
      return baseData;
    });
  
    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(tableData);
  
    // Create a workbook
    const workbook = {
      Sheets: { 'Data': worksheet },
      SheetNames: ['Data']
    };
  
    // Generate filename based on selectedValue
    let filename = 'Survey_Data';
    if (selectedValue) {
      filename = `Survey_${selectedValue.charAt(0).toUpperCase() + selectedValue.slice(1)}`;
    }
  
    // Export the workbook
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  };
   
  const calculateTotalAverage = () => {
    let total = 0;
    let count = 0;
  
    surveyFormData.forEach((row) => {
      if (!row?.forms) return; // Skip if no forms exist
  
      // Helper function to safely parse and add score
      const addScore = (value) => {
        if (value !== undefined && value !== null && value !== 'NA') {
          const num = parseFloat(value);
          if (!isNaN(num)) {
            total += num;
            count++;
          }
        }
      };
  
      if (selectedValue === 'all') {
        // Check all possible form types
        ['won', 'lost', 'design', 'designlost'].forEach(formType => {
          if (row?.forms[formType]?.[0]?.satisfactionavg) {
            addScore(row?.forms[formType][0]?.satisfactionavg);
          }
        });
  
        // Check execution form specifically
        if (row.forms.execution?.[0]) {
          addScore(row?.forms?.execution[0]?.satisfactionavg);
          addScore(row?.forms?.execution[0]?.experienceWithSalesTeam);
          addScore(row?.forms?.execution[0]?.experienceWithDesignTeam);
        }
      } else {
        // Handle specific form types
        switch (selectedValue) {
          case 'won':
          case 'lost':
          case 'design':
          case 'designlost':
            addScore(row?.forms[selectedValue]?.[0]?.satisfactionavg);
            break;
          
          case 'execution':
            if (row?.forms.execution?.[0]) {
              addScore(row?.forms?.execution[0]?.satisfactionavg);
              addScore(row?.forms?.execution[0]?.experienceWithSalesTeam);
              addScore(row?.forms?.execution[0]?.experienceWithDesignTeam);
            }
            break;
        
        }
      }
    });
  
    return count > 0 ? (total / count).toFixed(1) : '0.0';
  };
  
  const totalAvg = calculateTotalAverage();
  const calculateSectionAverages = () => {
    let salesWonTotal = 0, salesWonCount = 0;
    let salesLostTotal = 0, salesLostCount = 0;
    let designTotal = 0, designCount = 0;
    let designLostTotal = 0, designLostCount = 0;
    let executionTotal = 0, executionCount = 0;
    let salesHandoverTotal = 0, salesHandoverCount = 0;
    let designHandoverTotal = 0, designHandoverCount = 0;
  
    surveyFormData.forEach((row) => {
      if (!row?.forms) return;
  
      // Sales Won
      if (row?.forms?.won?.[0]?.satisfactionavg) {
        salesWonTotal += parseFloat(row.forms.won[0].satisfactionavg);
        salesWonCount++;
      }
  
      // Sales Lost
      if (row?.forms?.lost?.[0]?.satisfactionavg) {
        salesLostTotal += parseFloat(row.forms.lost[0].satisfactionavg);
        salesLostCount++;
      }
  
      // Design
      if (row?.forms?.design?.[0]?.satisfactionavg) {
        designTotal += parseFloat(row.forms.design[0].satisfactionavg);
        designCount++;
      }
  
      // Design Lost
      if (row?.forms?.designlost?.[0]?.satisfactionavg) {
        designLostTotal += parseFloat(row.forms.designlost[0].satisfactionavg);
        designLostCount++;
      }
  
      // Execution
      if (row?.forms?.execution?.[0]?.satisfactionavg) {
        executionTotal += parseFloat(row.forms.execution[0].satisfactionavg);
        executionCount++;
      }
  
      // Sales Handover
      if (row?.forms?.execution?.[0]?.experienceWithSalesTeam) {
        salesHandoverTotal += parseFloat(row.forms.execution[0].experienceWithSalesTeam);
        salesHandoverCount++;
      }
  
      // Design Handover
      if (row?.forms?.execution?.[0]?.experienceWithDesignTeam) {
        designHandoverTotal += parseFloat(row.forms.execution[0].experienceWithDesignTeam);
        designHandoverCount++;
      }
    });
  
    return {
      salesWonAvg: salesWonCount > 0 ? (salesWonTotal / salesWonCount).toFixed(1) : '0.0',
      salesLostAvg: salesLostCount > 0 ? (salesLostTotal / salesLostCount).toFixed(1) : '0.0',
      designAvg: designCount > 0 ? (designTotal / designCount).toFixed(1) : '0.0',
      designLostAvg: designLostCount > 0 ? (designLostTotal / designLostCount).toFixed(1) : '0.0',
      executionAvg: executionCount > 0 ? (executionTotal / executionCount).toFixed(1) : '0.0',
      salesHandoverAvg: salesHandoverCount > 0 ? (salesHandoverTotal / salesHandoverCount).toFixed(1) : '0.0',
      designHandoverAvg: designHandoverCount > 0 ? (designHandoverTotal / designHandoverCount).toFixed(1) : '0.0',
      overallAvg:totalAvg
    };
  };
  
  const sectionAverages = calculateSectionAverages();
  const setOverallAverages = []; 
 
  return (
    <div>
      <Paper className={classes.paper} style={{ textAlign: 'center', marginBottom: 20 }}>
        <Typography variant="h6" gutterBottom style={{ paddingTop: 10, fontSize: 27, fontWeight: 700 }}>
          Customer Survey Forms
        </Typography>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // Center horizontally
          gap: '24px',
          marginBottom: '16px'
        }}>
          <Autocomplete
            multiple
            value={selectedCenters}
            onChange={(e, v) => handleSelectionChange(v)}
            options={allExpCenter}
            getOptionLabel={(option) => option?.name}
            style={{ width: '40%' }}  // Adjust width
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Exp-Center"
                variant="outlined"
                autoComplete="off" // Disable browser autofill
              />
            )}
          />

        <FormControl style={{ width: '40%' }}>
          <Autocomplete
            multiple
            options={commonLocation}
            getOptionLabel={(option) => option.name || ''}
            value={getSelectedObjects()} // map back to full objects just for UI
            onChange={(e, v) => handleMultipleLocationData(v)} // store only _ids
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Location"
                variant="outlined"
              />
            )}
          />

        </FormControl>
        {userDetails?.roles && Array.isArray(userDetails.roles) && userDetails.roles.some(role =>
            [ROLENAME.Admin, ROLENAME.FinanceManager, ROLENAME.FinanceExecutive, ROLENAME.DataAnalyst].includes(role.name)) && (
              <>

                <TextField
                  select
                  labelId="project-doc"
                  label="Select Role"
                  variant="outlined"
                  value={selectedRole}
                  onChange={handleSelectRoles} // Call handleSelectRoles on change
                  style={{ width: '40%' }} // Adjust width
                >
                  <MenuItem value="Sales User">Sales Executive</MenuItem>
                  <MenuItem value="Assistant Sales Manager">Assistant Sales Manager</MenuItem>
                  <MenuItem value="Sales Manager">Sales Manager</MenuItem>
                  <MenuItem value="Design User">Design User</MenuItem>
                  <MenuItem value="Assistant Design Manager">Assistant Design Manager</MenuItem>
                  <MenuItem value="Design Manager">Design Manager</MenuItem>
                  <MenuItem value="Execution User">Execution User</MenuItem>
                  <MenuItem value="Execution Manager">Execution Manager</MenuItem>

                </TextField>


                <Grid item xs={12} md={3}>
                  <FormControl style={{ width: '120%', }}>
                    <Autocomplete
                      multiple
                      value={selectedUsers}  // Value bound to selectedUsers state
                      onChange={handleMultipleUsers}  // Handle multiple users selection
                      options={usersData}  // User data options
                      getOptionLabel={(option) => `${option.name} - ${option.isActive ? "Active" : "Inactive"}`}  // Display user name
                      filterSelectedOptions  // Prevent already selected options from appearing in the dropdown
                      renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                    />
                  </FormControl>

                </Grid>
              </>
            )}

          {userDetails?.roles && Array.isArray(userDetails.roles) && userDetails.roles.some(role =>
            [ROLENAME.DGM_Design, ROLENAME.DesignHead, ROLENAME.AGM_Design, ROLENAME.OperationDesignManager].includes(role.name)) && (
              <>

                <TextField
                  select
                  labelId="project-doc"
                  label="Select Role"
                  variant="outlined"
                  value={selectedRole}
                  onChange={handleSelectRoles} // Call handleSelectRoles on change
                  style={{ width: '40%' }} // Adjust width
                >

                  <MenuItem value="Design User">Design User</MenuItem>
                  <MenuItem value="Assistant Design Manager">Assistant Design Manager</MenuItem>
                  <MenuItem value="Design Manager">Design Manager</MenuItem>
                </TextField>

                <Grid item xs={12} sm={3}>
                  <FormControl style={{ width: '120%', marginTop: '0.30rem' }}>
                    <Autocomplete
                      multiple
                      value={selectedUsers}  // Value bound to selectedUsers state
                      onChange={handleMultipleUsers}  // Handle multiple users selection
                      options={usersData}  // User data options
                      getOptionLabel={(option) => `${option.name} - ${option.isActive ? "Active" : "Inactive"}`}  // Display user name
                      filterSelectedOptions  // Prevent already selected options from appearing in the dropdown
                      renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                    />
                  </FormControl>

                </Grid>
              </>
            )}

          {userDetails?.roles && Array.isArray(userDetails.roles) && userDetails.roles.some(role =>
            [ROLENAME.DesignManager].includes(role.name)) && (
              <>

                <TextField
                  select
                  labelId="project-doc"
                  label="Select Role"
                  variant="outlined"
                  value={selectedRole}
                  onChange={handleSelectRoles} // Call handleSelectRoles on change
                  style={{ width: '40%' }} // Adjust width
                >

                  <MenuItem value="Design User">Design User</MenuItem>
                  <MenuItem value="Assistant Design Manager">Assistant Design Manager</MenuItem>
                
                </TextField>

                <Grid item xs={12} sm={3}>
                  <FormControl style={{ width: '120%', marginTop: '0.30rem' }}>
                    <Autocomplete
                      multiple
                      value={selectedUsers}  // Value bound to selectedUsers state
                      onChange={handleMultipleUsers}  // Handle multiple users selection
                      options={usersData}  // User data options
                      getOptionLabel={(option) => `${option.name} - ${option.isActive ? "Active" : "Inactive"}`}  // Display user name
                      filterSelectedOptions  // Prevent already selected options from appearing in the dropdown
                      renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                    />
                  </FormControl>

                </Grid>
              </>
            )}

          {userDetails?.roles && Array.isArray(userDetails.roles) && userDetails.roles.some(role =>
            [ROLENAME.DGM_Sales, ROLENAME.SalesHead].includes(role.name)) && (
              <>

                <TextField
                  select
                  labelId="project-doc"
                  label="Select Role"
                  variant="outlined"
                  value={selectedRole}
                  onChange={handleSelectRoles} // Call handleSelectRoles on change
                  style={{ width: '40%' }} // Adjust width
                >

                  <MenuItem value="Sales User">Sales Executive</MenuItem>
                  <MenuItem value="Assistant Sales Manager">Assistant Sales Manager</MenuItem>
                  <MenuItem value="Sales Manager">Sales Manager</MenuItem>
                </TextField>


                <Grid item xs={12} sm={3}>
                  <FormControl style={{ width: '120%' }}>
                    <Autocomplete
                      multiple
                      value={selectedUsers}  // Value bound to selectedUsers state
                      onChange={handleMultipleUsers}  // Handle multiple users selection
                      options={usersData}  // User data options
                      getOptionLabel={(option) => `${option.name} - ${option.isActive ? "Active" : "Inactive"}`}  // Display user name
                      filterSelectedOptions  // Prevent already selected options from appearing in the dropdown
                      renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                    />
                  </FormControl>

                </Grid>
              </>
            )}

        {userDetails?.roles && Array.isArray(userDetails.roles) && userDetails.roles.some(role =>
            [ROLENAME.SalesManager].includes(role.name)) && (
              <>

                <TextField
                  select
                  labelId="project-doc"
                  label="Select Role"
                  variant="outlined"
                  value={selectedRole}
                  onChange={handleSelectRoles} // Call handleSelectRoles on change
                  style={{ width: '40%' }} // Adjust width
                >

                  <MenuItem value="Sales User">Sales Executive</MenuItem>
                  <MenuItem value="Assistant Sales Manager">Assistant Sales Manager</MenuItem>
                </TextField>


                <Grid item xs={12} sm={3}>
                  <FormControl style={{ width: '120%' }}>
                    <Autocomplete
                      multiple
                      value={selectedUsers}  // Value bound to selectedUsers state
                      onChange={handleMultipleUsers}  // Handle multiple users selection
                      options={usersData}  // User data options
                      getOptionLabel={(option) => `${option.name} - ${option.isActive ? "Active" : "Inactive"}`}  // Display user name
                      filterSelectedOptions  // Prevent already selected options from appearing in the dropdown
                      renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                    />
                  </FormControl>

                </Grid>
              </>
            )}

          {userDetails?.roles && Array.isArray(userDetails.roles) && userDetails.roles.some(role =>
            [ROLENAME.AssistantSalesManager].includes(role.name)) && (
              <>


                <TextField
                  select
                  labelId="project-doc"
                  label="Select Role"
                  variant="outlined"
                  value={selectedRole}
                  onChange={handleSelectRoles} // Call handleSelectRoles on change
                  style={{ width: '15%' }}  // Adjust width
                >

                  <MenuItem value="Sales User">Sales User</MenuItem>

                </TextField>


                <Grid item xs={12} sm={3}>
                  <FormControl style={{ width: '120%' }}>
                    <Autocomplete
                      multiple
                      value={selectedUsers}  // Value bound to selectedUsers state
                      onChange={handleMultipleUsers}  // Handle multiple users selection
                      options={usersData}  // User data options
                      getOptionLabel={(option) => `${option.name} - ${option.isActive ? "Active" : "Inactive"}`}  // Display user name
                      filterSelectedOptions  // Prevent already selected options from appearing in the dropdown
                      renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                    />
                  </FormControl>

                </Grid>
              </>
            )}

          {userDetails?.roles && Array.isArray(userDetails.roles) && userDetails.roles.some(role =>
            [ROLENAME.AssistantDesignManager].includes(role.name)) && (
              <>

                <TextField
                  select
                  labelId="project-doc"
                  label="Select Role"
                  variant="outlined"
                  value={selectedRole}
                  onChange={handleSelectRoles} // Call handleSelectRoles on change
                  style={{ width: '40%' }} // Adjust width
                >

                  <MenuItem value="Design User">Design User</MenuItem>

                </TextField>



                <Grid item xs={12} sm={3}>
                  <FormControl style={{ width: '120%' }}>
                    <Autocomplete
                      multiple
                      value={selectedUsers}  // Value bound to selectedUsers state
                      onChange={handleMultipleUsers}  // Handle multiple users selection
                      options={usersData}  // User data options
                      getOptionLabel={(option) => `${option.name} - ${option.isActive ? "Active" : "Inactive"}`}  // Display user name
                      filterSelectedOptions  // Prevent already selected options from appearing in the dropdown
                      renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                    />
                  </FormControl>

                </Grid>
              </>
            )}


          {userDetails?.roles && Array.isArray(userDetails.roles) && userDetails.roles.some(role =>
            [ROLENAME.Execution_Manager].includes(role.name)) && (
              <>


                <TextField
                  select

                  labelId="project-doc"
                  label="Select Role"
                  variant="outlined"
                  value={selectedRole}
                  onChange={handleSelectRoles} // Call handleSelectRoles on change
                  style={{ width: '40%' }} // Adjust width
                >

                  <MenuItem value="Execution User">Execution User</MenuItem>

                </TextField>

                <Autocomplete
                  multiple
                  style={{ width: '10%' }}  // Adjust width
                  value={selectedUsers}  // Value bound to selectedUsers state
                  onChange={handleMultipleUsers}  // Handle multiple users selection
                  options={usersData}  // User data options
                      getOptionLabel={(option) => `${option.name} - ${option.isActive ? "Active" : "Inactive"}`}  // Display user name
                  filterSelectedOptions  // Prevent already selected options from appearing in the dropdown
                  renderInput={(params) => <TextField {...params} label="Select Users" variant="outlined" />}
                />

              </>
            )}


          <br/><div></div>
          <TextField
            select
            label="Select Survey Form"  // The label for the dropdown
            value={selectedValue}
            onChange={handleSelectChange}
            variant="outlined"
            style={{ width: '15%' }}  // Set the width
            InputLabelProps={{
              shrink: true,  // Ensures the label stays above the dropdown when selected
            }}
          >
            {/* Mapping over the MenuItem options based on user roles */}
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="won">Sales - Won</MenuItem>
                <MenuItem value="lost">Sales - Lost</MenuItem>
                <MenuItem value="design">Design</MenuItem>
                <MenuItem value="designlost">Design - Lost</MenuItem>
                <MenuItem value="execution">Project Handover</MenuItem>
              

          </TextField>
        </div>


   {/* First Row - Inputs */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '24px',
        marginBottom: '16px',
        flexWrap: 'wrap'
      }}>

        {/* Search Type */}
        <TextField
          select
          label="Search Type"
          value={selectedSearchType}
          onChange={(e) => handle_search_type_selection(e.target.value)}
          variant="outlined"
          style={{ width: '15%' }}
        >
          {searchTypes.map((el) => (
            <MenuItem key={el.name} value={el}>
              {el.name}
            </MenuItem>
          ))}
        </TextField>

        {/* Input Field */}
        <TextField
          label="Enter the input"
          name="searched"
          value={searchInput}
          onKeyDown={setHandleSearchedByEnter}
          onChange={(e) => setSearchInput(e.target.value)}
          variant="outlined"
          style={{ width: '15%' }}
        />

        {/* Date Filter Dropdown */}
        <FormControl variant="outlined" style={{ width: '20%' }}>
          <Select
            value={dateType}
            onChange={handleDateTypeChange}
          >
            <MenuItem value="form-submission">Form Submission Date</MenuItem>
            <MenuItem value="project-completion">Project Completion Date</MenuItem>
          </Select>
        </FormControl>


        {/* Start Date */}
        <TextField
          label="Start Date"
          variant="outlined" 
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          style={{ width: '15%' }}
        />

        {/* End Date */}
        <TextField
          label="End Date"
          variant="outlined" 
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          style={{ width: '15%' }}
        />
      </div>

      {/* Second Row - Buttons */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '24px',
              flexWrap: 'wrap'
            }}>

              {/* Submit Button */}

              
              <Button
                className={classes.actionButton}
                variant="contained"
                  color="primary"
                  size="medium"
                onClick={handleDateSubmit}
                style={{ height: '56px', width: '15%' }}
              >
                Submit
              </Button>

              {/* Search Button (Role-Based) */}
              {userDetails?.roles?.find(role =>
                role.name !== 'Procurement Executive' && role.name !== 'Store Manager'
              ) && (
                <Button
                  disabled={!selectedSearchType || !searchInput}
                  variant="contained"
                  color="primary"
                  size="medium"
                  style={{ height: '56px', width: '15%' }}
                  onClick={() => getdataOnSelectedDate('someType')}
                  className={classes.searchButton}
                >
                  Search
                </Button>
              )}

        {/* Clear Filter Button */}
        <Button
          variant="contained"
          color="secondary"
          size="medium"
          onClick={clearFilterDate}
          style={{ height: '56px', width: '15%' }}
        >
          Clear
        </Button>

        {/* Download Button */}
        <Button
          onClick={downloadExcel}
          style={{
            height: '56px',
            width: '15%',
            background: 'green',
            color: 'white'
          }}
          className={classes.downloadButton}
        >
          Download as Excel
        </Button>
      </div>

      </Paper>

      <TableContainer component={Paper} className={classes.container}>
      <TablePagination
        rowsPerPageOptions={[100, 200, 500, 5000]}
        component="div"
        count={totalLength}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Table className={classes.table} aria-label="customer survey table">
      <TableHead>
        {/* First Header Row - Top Level */}
        <TableRow>
          <TableCell style={{ textAlign: 'center', fontWeight: 700 }} rowSpan={3}>S.No</TableCell>
          <TableCell style={{ textAlign: 'center', fontWeight: 700 }} rowSpan={3}>Customer/Project/Lead</TableCell>
          <TableCell style={{ textAlign: 'center', fontWeight: 700 }} rowSpan={3}>City</TableCell>
          <TableCell style={{ textAlign: 'center', fontWeight: 700 }} rowSpan={3}>Experience Center</TableCell>
          <TableCell style={{ textAlign: 'center', fontWeight: 700 }} rowSpan={3}>Current Stage</TableCell>
          
          {selectedValue === 'all' && (
            <>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={5} rowSpan={2}>Sales Executive, Designer, ADM, ODM, PM, </TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={2} rowSpan={2}>Sales Won NPS</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={2}rowSpan={2}>Sales Lost NPS</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={2} rowSpan={2}>Design NPS</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={2} rowSpan={2}>Design Lost NPS</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={6}>Project Handover</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={2} rowSpan={3}>Average NPS</TableCell>
            </>
          )}

          {selectedValue !== 'all' && (
            <>
              {selectedValue === 'won' && 
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={3} >Sales Won</TableCell>
              }
              {selectedValue === 'lost' &&
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={3} >Sales Lost</TableCell>
              }
              {selectedValue === 'design' &&
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={5} >Design</TableCell>
              }
              {selectedValue === 'designlost' &&
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={5} >Design Lost</TableCell>
              }
              {selectedValue === 'execution' && (
                <>
                  <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={9}>Project Handover</TableCell>
                  <TableCell style={{ fontWeight: 700, textAlign: 'center' }} rowSpan={3}>Project Handover Average NPS </TableCell>
                </>
              )}
            </>
          )}
        </TableRow>

        {/* Second Header Row - Middle Level (only for execution) */}
        {(selectedValue === 'all' || selectedValue === 'execution') && (
          <TableRow>
            {selectedValue === 'all' && (
              <>
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={2}>Execution Handover</TableCell>
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={2}>Sales Handover</TableCell>
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={2}>Design Handover</TableCell>
              </>
            )}
            {selectedValue === 'execution' && (
              <>
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={3}>Execution Handover</TableCell>
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={3}>Sales Handover</TableCell>
                <TableCell style={{ textAlign: 'center', fontWeight: 700 }} colSpan={3}>Design Handover</TableCell>
              </>
            )}
          </TableRow>
        )}

        {/* Third Header Row - Detailed Level */}
        <TableRow>
          {selectedValue === 'all' && (
            <>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Sales Executive</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Designer</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>ADM</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>ODM</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>PM</TableCell>
              
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
              
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
              
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
              
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
              
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
              
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
              
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
            </>
          )}

          {selectedValue === 'won' && (
            <>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Sales Executive</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date of Feedback</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
            </>
          )}

          {selectedValue === 'lost' && (
            <>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Sales Executive</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date of Feedback</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
            </>
          )}

          {selectedValue === 'design' && (
            <>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Designer</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>ADM</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>ODM</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date of Feedback</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
            </>
          )}

          {selectedValue === 'designlost' && (
            <>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Designer</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>ADM</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>ODM</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date of Feedback</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
            </>
          )}

          {selectedValue === 'execution' && (
            <>
              {/* Execution Handover columns */}
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Project Manager</TableCell>
              {dateType === 'project-completion' && <TableCell style={{ textAlign: 'center', fontWeight: 700 }}> Project Completion Date</TableCell>}
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date of Feedback</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
              
              {/* Sales Handover columns */}
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Sales Executive</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date of Feedback</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
              
              {/* Design Handover columns */}
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Designer</TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 700 }}>Date of Feedback</TableCell>
              <TableCell style={{ fontWeight: 700 }}>NPS</TableCell>
            </>
          )}
        </TableRow>
      </TableHead>
        
        {selectedValue === 'all' && (
          <TableBody>
          {surveyFormData?.map((row, i) => (
              <TableRow key={i + 1}>
                {/* S.No */}
                <TableCell component="th" scope="row">{i + 1}</TableCell>
                
                {/* Customer/Project/Lead */}
                <TableCell component="th" scope="row">
                  <div>
                    <button 
                      style={{ cursor: 'pointer', background: 'none', border: 'none', color: '#000', textDecoration: 'underline', padding: 0 }} 
                      onClick={(e) => {
                        e.stopPropagation();
                        const url = `/project-logs/${row?.leadId?._id}`;
                        window.open(url, '_blank');
                      }}
                    >
                      {row?.leadId?.customerId?.name} 
                    </button>
                  </div>
                  <div>
                    <strong>Project:</strong> {' '}
                    <button 
                      style={{ cursor: 'pointer', background: 'none', border: 'none', color: '#000', textDecoration: 'underline', padding: 0 }} 
                      onClick={(e) => {
                        e.stopPropagation();
                        const url = `/project-logs/${row?.leadId?._id}`;
                        window.open(url, '_blank');
                      }}
                    >
                      {row?.leadId?.erpProjectNo}
                    </button>
                  </div>
                  <div>
                    <strong>Lead:</strong> {row?.leadId?.lead_no}
                  </div>
                </TableCell>
                
                {/* City and Experience Center */}
                <TableCell component="th" scope="row">{row?.leadId?.city?.name || 'NA'}</TableCell>

                <TableCell component="th" scope="row">{row?.leadId?.experienceCenterId?.name || 'NA'}</TableCell>
                
                {/* Current Stage */}
                <TableCell component="th" scope="row">{row?.leadId?.currentStage || 'NA'}</TableCell>
                
                {/* Team Members */}
                <TableCell component="th" scope="row">{row?.forms?.won?.[0]?.leadOwner?.name || row?.forms?.lost?.[0]?.leadOwner?.name || 'NA'}</TableCell>
                <TableCell component="th" scope="row">{row?.forms?.design?.[0]?.leadOwner?.name || row?.forms?.designlost?.[0]?.leadOwner?.name || 'NA'}</TableCell>
                <TableCell component="th" scope="row">{row?.forms?.design?.length > 0 ? row?.forms?.design[0]?.leadOwner?.assistantManagerId?.name : "NA" }</TableCell>
                <TableCell component="th" scope="row">{row?.leadId?.designManager ? row?.leadId?.designManager?.name : "NA" } </TableCell>
                <TableCell component="th" scope="row">{row?.forms?.execution?.[0]?.leadOwner?.name || 'NA'}</TableCell>
                
                {/* Sales Won NPS */}
                <TableCell component="th" scope="row">{row?.forms?.won?.[0]?.createdAt ? moment(row.forms.won[0].createdAt).format('DD-MM-YYYY') : 'NA'}</TableCell>
                <TableCell component="th" scope="row">
                  {row?.forms?.won?.length > 0 && row?.forms?.won?.[0]?.satisfactionavg ? (
                    <Button color="primary" onClick={() => showCustomerForm('won', row.forms.won[0])}>
                      {row.forms.won[0].satisfactionavg}
                    </Button>
                  ) : 'NA'}
                </TableCell>
                
                {/* Sales Lost NPS */}
                <TableCell component="th" scope="row">{row?.forms?.lost?.[0]?.createdAt ? moment(row.forms.lost[0].createdAt).format('DD-MM-YYYY') : 'NA'}</TableCell>
                <TableCell component="th" scope="row">
                  {row?.forms?.lost?.length > 0 && row?.forms?.lost?.[0]?.satisfactionavg ? (
                    <Button color="primary" onClick={() => showCustomerForm('lost', row.forms.lost[0])}>
                      {row.forms.lost[0].satisfactionavg}
                    </Button>
                  ) : 'NA'}
                </TableCell>
                
                {/* Design NPS */}
                <TableCell component="th" scope="row">{row?.forms?.design?.[0]?.createdAt ? moment(row.forms.design[0].createdAt).format('DD-MM-YYYY') : 'NA'}</TableCell>
                <TableCell component="th" scope="row">
                  {row?.forms?.design?.length > 0 && row?.forms?.design?.[0]?.satisfactionavg ? (
                    <Button color="primary" onClick={() => showCustomerForm('design', row.forms.design[0])}>
                      {row.forms.design[0].satisfactionavg}
                    </Button>
                  ) : 'NA'}
                </TableCell>
                
                {/* Design Lost NPS */}
                <TableCell component="th" scope="row">{row?.forms?.designlost?.length > 0 ? moment(row.forms.designlost[0]?.createdAt).format('DD-MM-YYYY') || 'NA' : 'NA'}</TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.designlost?.length > 0 && row?.forms?.designlost?.[0]?.satisfactionavg ? (
                        <Button color="primary" onClick={() => showCustomerForm('designlost', row.forms.designlost[0])}>
                          {row.forms.designlost[0]?.satisfactionavg}
                        </Button>
                      ) : 'NA'}
                    </TableCell>
                
                {/* Execution NPS */}
                <TableCell component="th" scope="row">{row?.forms?.execution?.[0]?.createdAt ? moment(row.forms.execution[0].createdAt).format('DD-MM-YYYY') : 'NA'}</TableCell>
                <TableCell component="th" scope="row">
                  {row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.satisfactionavg ? (
                    <Button color="primary" onClick={() => showCustomerForm('execution', row.forms.execution[0])}>
                      {row.forms.execution[0].satisfactionavg}
                    </Button>
                  ) : 'NA'}
                </TableCell>
                
                {/* Sales Handover NPS */}
                <TableCell component="th" scope="row">{row?.forms?.execution?.[0]?.createdAt ? moment(row.forms.execution[0].createdAt).format('DD-MM-YYYY') : 'NA'}</TableCell>
                <TableCell component="th" scope="row">
                  {row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.experienceWithSalesTeam ? (
                    <Button color="primary" onClick={() => showCustomerForm('execution', row.forms.execution[0])}>
                      {row.forms.execution[0].experienceWithSalesTeam}
                    </Button>
                  ) : 'NA'}
                </TableCell>
                
                {/* Design Handover NPS */}
                <TableCell component="th" scope="row">{row?.forms?.execution?.[0]?.createdAt ? moment(row.forms.execution[0].createdAt).format('DD-MM-YYYY') : 'NA'}</TableCell>
                <TableCell component="th" scope="row">
                  {row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.experienceWithDesignTeam ? (
                    <Button color="primary" onClick={() => showCustomerForm('execution', row.forms.execution[0])}>
                      {row.forms.execution[0].experienceWithDesignTeam}
                    </Button>
                  ) : 'NA'}
                </TableCell>
                <TableCell component="th" scope="row">
                    {(() => {
                      // Collect all available NPS scores
                      const scores = [];
                      const totalPossibleForms = 5; // Total possible forms
                      
                      // Check for Won NPS
                      if (row?.forms?.won?.length > 0 && row?.forms?.won?.[0]?.satisfactionavg) {
                        scores.push(parseFloat(row.forms.won[0].satisfactionavg));
                      }
                      
                      // Check for Lost NPS
                      if (row?.forms?.lost?.length > 0 && row?.forms?.lost?.[0]?.satisfactionavg) {
                        scores.push(parseFloat(row.forms.lost[0].satisfactionavg));
                      }
                      
                      // Check for Design NPS
                      if (row?.forms?.design?.length > 0 && row?.forms?.design?.[0]?.satisfactionavg) {
                        scores.push(parseFloat(row.forms.design[0].satisfactionavg));
                      }
                      
                      // Check for Design Lost NPS
                      if (row?.forms?.designlost?.length > 0 && row?.forms?.designlost?.[0]?.satisfactionavg) {
                        scores.push(parseFloat(row.forms.designlost[0].satisfactionavg));
                      }
                      
                      // Check for Execution NPS
                      if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.satisfactionavg) {
                        scores.push(parseFloat(row.forms.execution[0].satisfactionavg));
                      }
                      
                      // Check for Sales Handover Experience
                      if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.experienceWithSalesTeam) {
                        scores.push(parseFloat(row.forms.execution[0].experienceWithSalesTeam));
                      }
                      
                      // Check for Design Handover Experience
                      if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.experienceWithDesignTeam) {
                        scores.push(parseFloat(row.forms.execution[0].experienceWithDesignTeam));
                      }
                      
                      // Calculate average if there are any scores
                      if (scores.length > 0) {
                        const sum = scores.reduce((acc, score) => acc + score, 0);
                        const average = (sum / scores.length);
                        const availableForms = scores.length;
                        setOverallAverages.push(average); 
                        return (
                          <Button color="primary">
                            {average.toFixed(1)} 
                          </Button>
                        );
                      }
                      
                      return 'NA';
                    })()}
              </TableCell>
              </TableRow>
          ))}
           
            {/* Total Average Row - Show separate averages for each section */}
          <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
            <TableCell colSpan={7} style={{ textAlign: 'right', fontWeight: 'bold' }}>
              Total Averages
            </TableCell>
            
            {/* Team Members - Empty as these are names */}
            <TableCell colSpan={3} style={{ textAlign: 'center' }}></TableCell>
            
            {/* Sales Won */}
            <TableCell style={{ textAlign: 'center' }}></TableCell>
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.salesWonAvg}
            </TableCell>
            
            {/* Sales Lost */}
            <TableCell style={{ textAlign: 'center' }}></TableCell>
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.salesLostAvg}
            </TableCell>
            
            {/* Design */}
            <TableCell style={{ textAlign: 'center' }}></TableCell>
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.designAvg}
            </TableCell>
            
            {/* Design Lost */}
            <TableCell style={{ textAlign: 'center' }}></TableCell>
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.designLostAvg}
            </TableCell>
            
            {/* Execution */}
            <TableCell style={{ textAlign: 'center' }}></TableCell>
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.executionAvg}
            </TableCell>
            
            {/* Sales Handover */}
            <TableCell style={{ textAlign: 'center' }}></TableCell>
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.salesHandoverAvg}
            </TableCell>
            
            {/* Design Handover */}
            <TableCell style={{ textAlign: 'center' }}></TableCell>
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.designHandoverAvg}
            </TableCell>
            
            {/* Overall Average */}
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {(() => {
                // If setOverallAverages is an array of numbers
                if (!Array.isArray(setOverallAverages) || setOverallAverages.length === 0) {
                  return 'NA';
                }
                
                const sum = setOverallAverages.reduce((total, num) => total + num, 0);
                const average = sum / setOverallAverages.length;
                
                return average.toFixed(1); // Format to 1 decimal place
              })()}
            </TableCell>
          </TableRow>
          </TableBody>
        )}
        
        {selectedValue !== 'all' && (
          <TableBody>
            {surveyFormData?.map((row, i) => (
              <TableRow key={i + 1}>
                {/* S.No */}
                <TableCell component="th" scope="row">{i + 1}</TableCell>
                
                {/* Customer/Project/Lead */}
                <TableCell component="th" scope="row">
                  <div>
                    <button 
                      style={{ cursor: 'pointer', background: 'none', border: 'none', color: '#000', textDecoration: 'underline', padding: 0 }} 
                      onClick={(e) => {
                        e.stopPropagation();
                        const url = `/project-logs/${row?.leadId?._id}`;
                        window.open(url, '_blank');
                      }}
                    >
                      {row?.leadId?.customerId?.name} 
                    </button>
                  </div>
                  <div>
                    <strong>Project:</strong> {' '}
                    <button 
                      style={{ cursor: 'pointer', background: 'none', border: 'none', color: '#000', textDecoration: 'underline', padding: 0 }} 
                      onClick={(e) => {
                        e.stopPropagation();
                        const url = `/project-logs/${row?.leadId?._id}`;
                        window.open(url, '_blank');
                      }}
                    >
                      {row?.leadId?.erpProjectNo}
                    </button>
                  </div>
                  <div>
                    <strong>Lead:</strong> {row?.leadId?.lead_no}
                  </div>
                </TableCell>
                
                {/* Experience Center */}
                <TableCell component="th" scope="row">{row?.leadId?.city?.name || 'NA'}</TableCell>

                <TableCell component="th" scope="row">{row?.leadId?.experienceCenterId?.name || 'NA'}</TableCell>
                
                {/* Current Stage */}
                <TableCell component="th" scope="row">{row?.leadId?.currentStage || 'NA'}</TableCell>
                
                {/* Conditional columns based on selectedValue */}
                {selectedValue === 'won' && (
                  <>
                    <TableCell component="th" scope="row">{row?.forms?.won?.length > 0 ? row.forms.won[0]?.leadOwner?.name || 'NA' : 'NA'}</TableCell>
                    <TableCell component="th" scope="row">{row?.forms?.won?.length > 0 ? moment(row.forms.won[0]?.createdAt).format('DD-MM-YYYY') || 'NA' : 'NA'}</TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.won?.length > 0 && row?.forms?.won?.[0]?.satisfactionavg ? (
                        <Button color="primary" onClick={() => showCustomerForm('won', row.forms.won[0])}>
                          {row.forms.won[0]?.satisfactionavg}
                        </Button>
                      ) : 'NA'}
                    </TableCell>
                  </>
                )}
                
                {selectedValue === 'lost' && (
                  <>
                    <TableCell component="th" scope="row">{row?.forms?.lost?.length > 0 ? row.forms.lost[0]?.leadOwner?.name || 'NA' : 'NA'}</TableCell>
                    <TableCell component="th" scope="row">{row?.forms?.lost?.length > 0 ? moment(row.forms.lost[0]?.createdAt).format('DD-MM-YYYY') || 'NA' : 'NA'}</TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.lost?.length > 0 && row?.forms?.lost?.[0]?.satisfactionavg ? (
                        <Button color="primary" onClick={() => showCustomerForm('lost', row.forms.lost[0])}>
                          {row.forms.lost[0]?.satisfactionavg}
                        </Button>
                      ) : 'NA'}
                    </TableCell>
                  </>
                )}
                
                {selectedValue === 'design' && (
                  <>
                    <TableCell component="th" scope="row">
                      {row?.forms?.design?.length > 0 ? row.forms.design[0]?.leadOwner?.name || 'NA' : 'NA'}
                    </TableCell>
                    <TableCell component="th" scope="row">
                       {row?.forms?.design?.length > 0 ? row?.forms?.design[0]?.leadOwner?.assistantManagerId?.name : "NA" }
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.leadId?.designManager ? row?.leadId?.designManager?.name : "NA" }
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.design?.length > 0 ? moment(row.forms.design[0]?.createdAt).format('DD-MM-YYYY') || 'NA' : 'NA'}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.design?.length > 0 && row?.forms?.design?.[0]?.satisfactionavg ? (
                        <Button color="primary" onClick={() => showCustomerForm('design', row.forms.design[0])}>
                          {row.forms.design[0]?.satisfactionavg}
                        </Button>
                      ) : 'NA'}
                    </TableCell>
                  </>
                )}
                
                {selectedValue === 'designlost' && (
                  <>
                    <TableCell component="th" scope="row">
                      {row?.forms?.designlost?.length > 0 ? row.forms.designlost[0]?.leadOwner?.name || 'NA' : 'NA'}
                    </TableCell>
                     <TableCell component="th" scope="row">
                      {row?.forms?.design?.length > 0 ? row?.forms?.design[0]?.leadOwner?.assistantManagerId?.name : "NA" }
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.leadId?.designManager ? row?.leadId?.designManager?.name : "NA" }
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.designlost?.length > 0 ? moment(row.forms.designlost[0]?.createdAt).format('DD-MM-YYYY') || 'NA' : 'NA'}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.designlost?.length > 0 && row?.forms?.designlost?.[0]?.satisfactionavg ? (
                        <Button color="primary" onClick={() => showCustomerForm('design-lost', row.forms.designlost[0])}>
                          {row.forms.designlost[0]?.satisfactionavg}
                        </Button>
                      ) : "NA"}
                    </TableCell>
                  </>
                )}
                
                {selectedValue === 'execution' && (
                  <>
                    <TableCell component="th" scope="row">
                      {row?.forms?.execution?.length > 0 ? row.forms.execution[0]?.leadOwner?.name || row?.leadId?.assignTo?.name : 'NA'}
                    </TableCell>
                  {dateType === 'project-completion' && (
              <TableCell component="th" scope="row">
                {(() => {
                  const mwpDate = row?.leadId?.executionMWPDate;
                  const completionDate = row?.leadId?.executionCompletionDate;
                  
                  // Check if executionMWPDate is available and valid
                  if (mwpDate && mwpDate !== "" && moment(mwpDate).isValid()) {
                    return moment(mwpDate).format('DD-MM-YYYY');
                  }
                  // Fall back to executionCompletionDate if MWP date is not available
                  else if (completionDate && completionDate !== "" && moment(completionDate).isValid()) {
                    return moment(completionDate).format('DD-MM-YYYY');
                  }
                  // If neither date is available or valid
                  else {
                    return 'NA';
                  }
                })()}
              </TableCell>
            )}
                                <TableCell component="th" scope="row">
                      {row?.forms?.execution?.[0]?.satisfactionIndexRatio?.length > 0 &&
                      moment(row.forms.execution[0]?.createdAt).isValid()
                        ? moment(row.forms.execution[0].createdAt).format('DD-MM-YYYY')
                        : 'NA'}
                    </TableCell>

                    <TableCell component="th" scope="row">
                    <Button
                      color="primary"
                      disabled={
                        !row?.forms?.execution?.[0]?.satisfactionavg ||
                        row.forms.execution[0].satisfactionavg === 'NA'
                      }
                      onClick={() =>
                        row?.forms?.execution?.[0]?.satisfactionavg !== 'NA' &&
                        showCustomerForm('execution', row.forms.execution[0])
                      }
                    >
                      {row?.forms?.execution?.[0]?.satisfactionavg || 'NA'}
                    </Button>
                  </TableCell>

                    <TableCell component="th" scope="row">{row?.leadId?.salesWonUserName || 'NA'}</TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.execution?.[0]?.satisfactionIndexRatio?.length > 0 &&
                      moment(row.forms.execution[0]?.createdAt).isValid()
                        ? moment(row.forms.execution[0].createdAt).format('DD-MM-YYYY')
                        : 'NA'}
                    </TableCell>


                      <TableCell component="th" scope="row">
                        <Button
                          color="primary"
                          disabled={!row?.forms?.execution?.[0]?.experienceWithSalesTeam}
                          onClick={() =>
                            row?.forms?.execution?.[0]?.experienceWithSalesTeam &&
                            showCustomerForm('execution', row.forms.execution[0])
                          }
                        >
                          {row?.forms?.execution?.[0]?.experienceWithSalesTeam || 'NA'}
                        </Button>
                      </TableCell>

                    <TableCell component="th" scope="row">{row?.leadId?.designSignOffUserName || 'NA'}</TableCell>
                    <TableCell component="th" scope="row">
                      {row?.forms?.execution?.[0]?.satisfactionIndexRatio?.length > 0 &&
                      moment(row.forms.execution[0]?.createdAt).isValid()
                        ? moment(row.forms.execution[0].createdAt).format('DD-MM-YYYY')
                        : 'NA'}
                    </TableCell>


                    <TableCell component="th" scope="row">
                      <Button
                        color="primary"
                        disabled={!row?.forms?.execution?.[0]?.experienceWithDesignTeam}
                        onClick={() =>
                          row?.forms?.execution?.[0]?.experienceWithDesignTeam &&
                          showCustomerForm('execution', row.forms.execution[0])
                        }
                      >
                        {row?.forms?.execution?.[0]?.experienceWithDesignTeam || 'NA'}
                      </Button>
                    </TableCell>

                    {/* New column for total NPS average */}
                    <TableCell component="th" scope="row">
                    {(() => {
                      // Collect all available NPS scores
                      const scores = [];                  
                      // Check for Execution NPS
                      if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.satisfactionavg) {
                        scores.push(parseFloat(row.forms.execution[0].satisfactionavg));
                      }
                      
                      // Check for Sales Handover Experience
                      if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.experienceWithSalesTeam) {
                        scores.push(parseFloat(row.forms.execution[0].experienceWithSalesTeam));
                      }
                      
                      // Check for Design Handover Experience
                      if (row?.forms?.execution?.length > 0 && row?.forms?.execution?.[0]?.experienceWithDesignTeam) {
                        scores.push(parseFloat(row.forms.execution[0].experienceWithDesignTeam));
                      }
                      
                      // Calculate average if there are any scores
                      if (scores.length > 0) {
                        const sum = scores.reduce((acc, score) => acc + score, 0);
                        const average = (sum / scores.length).toFixed(1);
                        const availableForms = scores.length;
                      
                        return (
                          <Button color="primary">
                            {!isNaN(+average) ? average : "NA"}
                          </Button>
                        );
                      }
                      
                      
                      return 'NA';
                    })()}
                  </TableCell>
                  </>
                )}
          </TableRow>
            ))}
         {selectedValue === 'execution' ? (
            <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
            <TableCell colSpan={5} style={{ textAlign: 'right', fontWeight: 'bold' }}>
              Total Averages
            </TableCell>
            
            {/* Execution */}
            <TableCell></TableCell> 
            <TableCell></TableCell> 
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.executionAvg}
            </TableCell>
            
            {/* Sales Handover */}
            <TableCell></TableCell> 
            <TableCell></TableCell> 
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.salesHandoverAvg}
            </TableCell>
            
            {/* Design Handover */}
            <TableCell></TableCell> 
            <TableCell></TableCell> 
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.designHandoverAvg}
            </TableCell>
            
            {/* Overall Average */}
            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
              {sectionAverages.overallAvg || "NA"}
            </TableCell>
            </TableRow>
          ) :  (selectedValue === 'designlost'  || selectedValue === 'design' ) ?   
          (
            <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
              <TableCell colSpan={9} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                Total Average NPS
              </TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
                {totalAvg || "NA"}
              </TableCell>
            </TableRow>
          ):
           (
            <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
              <TableCell colSpan={7} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                Total Average NPS
              </TableCell>
              <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>
                {totalAvg || "NA"}
              </TableCell>
            </TableRow>
          )
        }
          </TableBody>
          )}
      </Table>
    </TableContainer>


    </div>
  )
}
export default connect(null, { setLoading, setSnackInfo })(ViewCustomerSurveyForms)